// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__TqCmn","inlineIndicator":"styles_inlineIndicator__Ec8RB"};